import { h } from 'preact';

import Grid from '@mui/material/Grid';

import LazyLcpIssueDetail from './lazyIssueDetail.jsx';

export default function LazyLcpIssueDetails(_props) {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <LazyLcpIssueDetail />
      </Grid>
    </Grid>
  );
}
